module.exports = __webpack_public_path__ + "static/media/Cats eyes 02_TYSKA-mixdown.0c5a81d0.mp3";